import type { Translations } from "../types";

const vi: Translations = {
  "meta.title": "Lượt Click theo Bản Đồ Quốc Gia",
  "meta.description":
    "Bản đồ thế giới tương tác: lượt click miễn phí theo từng quốc gia, cùng hỗ trợ trả phí qua Stripe, PayPal và Buy Me a Coffee.",

  "app.title": "Lượt Click theo Bản Đồ Quốc Gia",

  "map.intro":
    "Nhấp vào một quốc gia trên bản đồ để bình chọn miễn phí, hoặc gửi hỗ trợ tài chính - cả hai đều được tính vào bảng xếp hạng tổng hợp bên dưới. Bản đồ chỉ phản ánh sự ủng hộ trong ứng dụng này, không phải sự giàu có hay GDP thực tế của quốc gia.",
  "map.verifying": "Đang xác minh …",
  "map.confirmNotRobot": "Trước khi thêm lượt click miễn phí, hãy xác nhận nhanh rằng bạn không phải robot:",
  "map.tryAgain": "Thử lại",
  "map.registeringClick": "Đang ghi nhận lượt click …",
  "map.selectedCountry": "Quốc gia đã chọn: {name}.",
  "map.selectFirstFeedback": "Đã chọn quốc gia. Để thêm lượt click miễn phí, trước tiên hãy xác nhận bên dưới rằng bạn không phải robot.",
  "map.verificationExpired": "Xác minh đã hết hạn - hãy xác nhận lại rằng bạn không phải robot.",
  "map.slowDown": "Chậm lại một chút - hãy đợi một lát trước khi click tiếp.",
  "map.clickFailed": "Không thể ghi nhận lượt click. Vui lòng thử lại.",
  "map.clickErrorGeneric": "Lỗi khi ghi nhận lượt click.",
  "map.leaderboardHeading": "Bảng Xếp Hạng Quốc Gia",
  "map.emptySelection": "Chọn một quốc gia trên bản đồ để click hoặc ủng hộ.",
  "map.loadingData": "Đang tải dữ liệu …",

  "worldmap.loadError": "Không thể tải bản đồ.",
  "worldmap.resetZoom": "Đặt lại độ phóng",
  "worldmap.resetButton": "⤾ Đặt lại",
  "worldmap.loadingMap": "Đang tải bản đồ …",
  "worldmap.unknownCountry": "Không xác định",
  "worldmap.ariaClicks": "{name}: {clicks} lượt click",
  "worldmap.tooltipClicks": "{clicks} lượt click",

  "legend.fewer": "Ít lượt click hơn",
  "legend.more": "Nhiều lượt click hơn",

  "list.empty": "Chưa có lượt click nào. Hãy là người đầu tiên!",
  "list.ariaLabel": "Bảng xếp hạng quốc gia theo lượt click",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY chưa được thiết lập - xem README để biết cách cấu hình.",
  "human.verificationFailedGeneric": "Xác minh thất bại.",
  "human.networkError":
    "Không thể kết nối để xác minh (lỗi mạng) - kiểm tra VITE_SUPABASE_URL, đảm bảo verify-human đã được triển khai, và ALLOWED_ORIGIN; xem README/NAVODILA.",
  "human.verificationFailedRetry": "Xác minh thất bại, hãy thử lại.",

  "provider.stripe": "💳 Thẻ (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Quốc gia đã chọn",
  "panel.currentlyRanked": "Hiện đang xếp hạng #{rank}",
  "panel.shareCopied": "Đã sao chép ✓",
  "panel.shareShared": "Đã chia sẻ ✓",
  "panel.shareButton": "🔗 Chia sẻ",

  "panel.tableClicks": "Lượt click",
  "panel.tableFree": "Miễn phí",
  "panel.tablePaid": "Trả phí",
  "panel.rowAllTime": "Toàn thời gian",
  "panel.rowThisYear": "Năm nay",
  "panel.rowThisWeek": "Tuần này",
  "panel.rowToday": "Hôm nay",

  "panel.totalCombined": "Tổng cộng:",
  "panel.totalSupport": "Tổng hỗ trợ:",

  "panel.paymentMethod": "Phương thức thanh toán",
  "panel.noPaymentMethod": "Hiện không có phương thức thanh toán nào khả dụng.",
  "panel.supportAmount": "Số tiền hỗ trợ (EUR)",
  "panel.amountRange": "Số tiền phải nằm trong khoảng từ {min} đến {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Số lượt click trả phí ước tính:",
  "panel.ratioInfo":
    "Tỷ lệ: {a} = {b} lượt click (ví dụ: {c} = {d} lượt click). Đây chỉ là ước tính trước khi thanh toán - số lượt click cuối cùng luôn được máy chủ tính toán và xác nhận dựa trên khoản thanh toán thực tế đã được xác nhận.",
  "panel.preparing": "Đang chuẩn bị …",
  "panel.continueWith": "Tiếp tục với {provider}",
  "panel.choosePaymentMethod": "Chọn phương thức thanh toán",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME chưa được thiết lập - xem README để biết cách cấu hình.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID chưa được thiết lập - xem README để biết cách cấu hình.",

  "panel.paypalAmountInfo": "Số tiền: {amount} (ước tính {clicks} lượt click). Hoàn tất thanh toán bằng nút PayPal bên dưới.",
  "panel.back": "← Quay lại",

  "panel.bmcWarningTitle": "⚠️ Trước khi tiếp tục đến BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Dán mã bên dưới vào ô tin nhắn/ghi chú khi thanh toán — đó là cách duy nhất để chúng tôi biết bạn đang ủng hộ quốc gia nào. Nếu không có mã này, chúng tôi không thể gán khoản thanh toán cho bất kỳ quốc gia nào.",
  "panel.copy": "Sao chép",
  "panel.copied": "Đã sao chép ✓",
  "panel.suggestedAmount": "Số tiền đề xuất:",
  "panel.bmcAmountNote":
    "(ước tính {clicks} lượt click). Rất tiếc BuyMeCoffee không hỗ trợ chuyển số tiền qua liên kết — hãy tự nhập/chọn số tiền trên trang của họ. Số lượt click thực tế luôn được tính từ số tiền bạn thực sự gửi trên BuyMeCoffee, không phải từ ước tính này.",
  "panel.openBmc": "Mở BuyMeCoffee và tiếp tục →",
  "panel.waitingProvider": "Đang chờ xác nhận thanh toán từ nhà cung cấp thanh toán …",
  "panel.waitingConfirmation": "Đang chờ xác nhận thanh toán …",
  "panel.timedOut":
    "Quá trình kiểm tra đã hết thời gian chờ. Nếu bạn đã hoàn tất thanh toán, bản đồ sẽ cập nhật ngay khi máy chủ nhận được xác nhận - đôi khi việc này có thể mất thêm chút thời gian.",
  "panel.checkAgain": "Kiểm tra lại",

  "panel.cancelled": "Thanh toán đã bị hủy hoặc không thành công. Bản đồ chưa thay đổi.",
  "panel.tryAgain": "Thử lại",

  "panel.confirmed": "✅ Đã xác nhận hỗ trợ!",
  "panel.confirmedBody": "{country} đã nhận được {clicks} lượt click trả phí với {amount}.",

  "panel.errorPreparingSupport": "Lỗi khi chuẩn bị khoản hỗ trợ của bạn.",
  "panel.errorPreparingPayment": "Lỗi khi chuẩn bị thanh toán.",
  "panel.errorConfirmingPayment": "Lỗi khi xác nhận thanh toán.",
  "panel.errorPayingPaypal": "Lỗi khi thanh toán bằng PayPal.",

  "share.unranked": "{flag}{country} cần sự ủng hộ của bạn trên bản đồ thế giới!\nGiúp quốc gia này leo lên bảng xếp hạng 👇",
  "share.rank1": "{flag}{country} hiện đang đứng #1!\nGiúp chúng tôi giữ vững vị trí dẫn đầu 👇",
  "share.rankN": "{flag}{country} hiện đang xếp hạng #{rank}!\nGiúp chúng tôi vươn lên #1 👇",

  "language.switcherLabel": "Ngôn ngữ",
};

export default vi;
